import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "@components/structure/Footer/Footer";
import WelcomeTitle from "@components/display/WelcomeTitle/WelcomeTitle";
import useProcessCoupon from "@hooks/process-coupon";
import Header from "@components/structure/Header/Header";
import styles from "./AuthLayout.module.css";

const AuthLayout: React.FC = () => {
    useProcessCoupon();
    return (
        <div className={styles.appContainer}>
            <Header variant="public" />
            <main className={styles.main}>
                <WelcomeTitle />
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default AuthLayout;
